import { render, staticRenderFns } from "./FantasyInfo.vue?vue&type=template&id=9dbf7846&"
import script from "./FantasyInfo.vue?vue&type=script&lang=js&"
export * from "./FantasyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports